/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LocationBasedDateIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Location Based Date',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="8" rx="1" ry="1" width="8" x="22" y="16" />
    <path
      d="M35 4h-5V1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3H14V1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3H5a1 1 0 0 0-1 1v6.109a10.633 10.633 0 0 1 2-.809V6h4v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6h12v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6h4v22H17.143a49.728 49.728 0 0 1-1.17 2H35a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
    />
    <path
      d="M9 12.367a8.25 8.25 0 0 0-8.25 8.25C.75 25.173 9 35.57 9 35.57s8.25-10.4 8.25-14.953A8.25 8.25 0 0 0 9 12.367Zm0 11.75a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5Z"
    />
  </svg>`;
};
